import { useEffect, useState } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import type { SearchScope } from '../api/searchTypes';

export interface SearchBarProps {
    value: string;
    scope: SearchScope;
    onQueryChange: (value: string) => void;
}

// The scope toggle moved to ScopeChips above the filter column (spec 6.1).
export function SearchBar({ value, scope, onQueryChange }: SearchBarProps) {
    const [draft, setDraft] = useState(value);

    useEffect(() => {
        setDraft(value);
    }, [value]);

    useEffect(() => {
        if (draft === value) return;
        const timer = setTimeout(() => onQueryChange(draft), 300);
        return () => clearTimeout(timer);
    }, [draft, value, onQueryChange]);

    return (
        <TextField
            fullWidth
            hiddenLabel
            size="small"
            margin="none"
            value={draft}
            placeholder={
                scope === 'trader'
                    ? 'Search traders by address or @name'
                    : 'Search events, markets, series and tags'
            }
            onChange={e => setDraft(e.target.value)}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                    </InputAdornment>
                ),
            }}
        />
    );
}
